import { Component, OnDestroy } from '@angular/core';
import { MailTemplateComponent } from 'components/admin/mail-template/mail-template.component';
import { CredentialType } from 'enums/CredentialType';
import { MailTemplateType } from 'enums/MailTemplateType';
import { MessageType } from 'enums/MessageType';
import { MailTemplateModel } from 'models/generated/Communication.Api.Models.MailTemplate';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { CredentialRequired } from 'services/credential.service';
import { MailService } from 'services/mail.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';

@Component({
	selector: 'list-mail-templates',
	templateUrl: './list-mail-templates.component.html',
	imports: [Layout, ListView, TranslatePipe]
})
@ComponentUrl('list-mail-templates')
@CredentialRequired(CredentialType.MailTemplatesAccessFull)
export class ListMailTemplatesComponent implements OnDestroy {

	mailTemplates: MailTemplateModel[] = [];
	selectedMailTemplate?: MailTemplateModel;
	loading = true;
	templateType = MailTemplateType;

	constructor(private readonly navigation: NavigationService,
		private readonly mailService: MailService,
		private readonly pushService: PushService,
		private readonly notification: NotificationService) {

		this.updateMailTemplateList();
		this.pushService.onChanges<any>(MessageType.MailTemplateChanges).subscribe(event => {
			this.updateMailTemplateList();
		});
	}

	updateMailTemplateList() {
		this.mailService.getMailTemplates().then(mailTemplates => {
			Object.assign(this.mailTemplates, mailTemplates);
			this.loading = false;
		});
	}

	displayMailTemplate(mailTemplate: MailTemplateModel) {
		this.navigation.openRelativeView(this, 'list-mail-templates', MailTemplateComponent).then(view => {
			view.mailTemplateId = mailTemplate.id as string
		});
		this.selectedMailTemplate = mailTemplate;
	}

	createMailTemplate() {
		this.navigation.openRelativeView(this, 'list-mail-templates', MailTemplateComponent);
		this.selectedMailTemplate = undefined;
	}

	deleteMailTemplate(mailTemplate: MailTemplateModel) {
		this.notification.confirm('mail-template.prompt-for-delete', { 'mailTemplate.title': mailTemplate.title }).subscribe(result => {
			if (result)
				this.mailService.deleteMailTemplate(mailTemplate.id as string)
		});
	}

	ngOnDestroy() {
	}
}
